import { StarCogIcon } from './StarCogIcon';

/**
 * author: Colton Wiscombe
 * id 82407F8C-2E0B-4F79-9409-0C267A248470
 * name star-cog
 * version: 5.7.55
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/star-cog.svg
 * tags
 * - Settings 
 */
export const FavoriteCogIcon = StarCogIcon;
export default FavoriteCogIcon